// @flow

import type { Reducer } from 'redux';
import { combineReducersFlat } from './utils';
import type { Action as AllActions } from './state';
import type { Action as HotelsAction, State as HotelState } from './page/hotels';
import hotels, { setPageOffset, poll } from './page/hotels';
import type { Action as HotelReviewAction, State as HotelReviewState } from './page/hotelreview';
import hotelreview, {
  crossSellsPoll,
  setCrossSellsEndpointResults,
  setUIAssets,
  registerLocation,
  refreshPrices,
  setIsMetaWithVp,
} from './page/hotelreview';
import type { State as GeoState } from './page/geo';
import geo from './page/geo';
import type { Action as InspirationAction, State as InspirationState } from './page/inspiration';
import type { State as DetailState } from './page/detail';
import detail from './page/detail';
import type { State as ProfileState } from './page/profile';
import profile from './page/profile';
import type { State as PhotoState } from './page/photo';
import photo from './page/photo';
import inspiration from './page/inspiration';

export type State =
  | HotelState
  | HotelReviewState
  | GeoState
  | DetailState
  | ProfileState
  | PhotoState
  | InspirationState;

export type Action = HotelsAction | InspirationAction | HotelReviewAction;

export const pageActions = {
  hotels: {
    poll,
    setPageOffset,
  },
  hotelreview: {
    crossSellsPoll,
    setCrossSellsEndpointResults,
    setUIAssets,
    registerLocation,
    refreshPrices,
    setIsMetaWithVp,
  },
};

export default ((combineReducersFlat(
  hotels,
  geo,
  detail,
  profile,
  photo,
  inspiration,
  hotelreview,
): any): Reducer<State, AllActions>);
